import { Signal } from '@angular/core';
import { PushDeviceEntry } from '@tourfold/libraries/tf-api-client-frontend-v2';
import { providePageContext } from '@tourfold/shared-kernels/page-context';
import { DevicePlatformValue } from './shared/push-device-filters/push-device-filters';

const MAX_VISIBLE_DEVICES = 25;

export interface PushNotificationsAiPageContextSignals {
  readonly activeTab: Signal<string>;
  readonly devices: Signal<PushDeviceEntry[]>;
  readonly searchQuery: Signal<string>;
  readonly platformTypeFilter: Signal<DevicePlatformValue | null>;
  readonly testingDevice: Signal<PushDeviceEntry | null>;
}

export function providePushNotificationsAiPageContext(
  state: PushNotificationsAiPageContextSignals,
): void {
  providePageContext(() => {
    const focused = state.testingDevice();
    const search = state.searchQuery().trim();
    const platform = state.platformTypeFilter();

    return {
      entity: focused
        ? {
            type: 'push_device',
            id: focused.id ?? '',
            label: `${focused.lastname ?? ''}, ${focused.firstname ?? ''}`.trim(),
          }
        : undefined,
      visible_rows: state
        .devices()
        .slice(0, MAX_VISIBLE_DEVICES)
        .map((device) => ({
          type: 'push_device',
          id: device.id ?? '',
          label: `${device.lastname ?? ''}, ${device.firstname ?? ''} (${device.platformType ?? 'UNKNOWN'})`,
        })),
      filters: {
        ...(state.activeTab() && { tab: state.activeTab() }),
        ...(search.length > 0 && { search }),
        ...(platform && { platform_type: platform }),
      },
    };
  });
}
